/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Remove_Confirmmodal_Title2Inputs */

const en_coinvestments_prospects_remove_confirmmodal_title2 = /** @type {(inputs: Coinvestments_Prospects_Remove_Confirmmodal_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove prospect`)
};

/**
* | output |
* | --- |
* | "Remove prospect" |
*
* @param {Coinvestments_Prospects_Remove_Confirmmodal_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_remove_confirmmodal_title2 = /** @type {((inputs?: Coinvestments_Prospects_Remove_Confirmmodal_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Remove_Confirmmodal_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_remove_confirmmodal_title2(inputs)
});
export { coinvestments_prospects_remove_confirmmodal_title2 as "coInvestments_prospects_remove_confirmModal_title" }